import * as React from 'react';
import styled from 'styled-components';
import { Link as GatsbyLink } from 'gatsby';
import ArrowLong from '../assets/images/arrow-long.svg';

const LinkStyles = `
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  color: var(--mainNeutral);
  border: var(--borderMain);
  border-radius: 30px;
  background-color: white;
  transition: all 0.2s;
  text-transform: uppercase;
  font-weight: var(--fontWeight);
  font-size: 1.1rem;
  padding: 13px 18px;
  -webkit-tap-highlight-color: transparent;
  flex-shrink: 0;

  &:hover {
    box-shadow: 0 2px 0 var(--mainNeutral);
    transform: translate(0, -2px);
    transition: all 0.2s;
    text-decoration: none;
  }

  span {
    margin-right: 10px;
  }
`;

const GatsbyLinkStyled = styled(GatsbyLink)`
  ${LinkStyles}
`;

const LinkStyled = styled.a`
  ${LinkStyles}
`;

export default function Link({ to, text, isLocalLink = true, className }) {
  const Component = isLocalLink ? GatsbyLinkStyled : LinkStyled;
  const props = isLocalLink ? { to } : { href: to, target: '_blank', rel: 'noopener noreferrer' };
  return (
    <Component {...props} className={className}>
      <span>{text}</span>
      <img src={ArrowLong} alt="arrow to the right" />
    </Component>
  );
}
